import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "breadCrumbNav" }

import { watchEffect, ref, watch, computed, onMounted } from 'vue';
import { RouteRecordRaw, useRoute } from 'vue-router';
import { targetAPI } from '@/api/target';
import { Target } from '@/store/modules/target/types';


import { defineComponent } from 'vue';
const __default__ = defineComponent({
    name: "BreadCrumbNav",
});


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const route = useRoute();
const paths = ref<RouteRecordRaw[]>([]);

const excludePaths = [
    "ProjectList",
    "TargetList"
]
const targetId = computed(() => route.params.targetId)
const selectedTarget = ref<Target>()

const getSelectedTarget = async () => {
    let projId = typeof (route.params.projId) === "string" ? route.params.projId : route.params.projId[0]
    let uid = typeof (route.params.targetId) === "string" ? route.params.targetId : route.params.targetId[0]
    const target = await targetAPI.getTargetByProjIdAndUid(projId, uid)
    selectedTarget.value = target
}

watch(targetId, async (newValue: any, oldValue: any) => {
    if (targetId.value != undefined) {
        await getSelectedTarget()
    }
});

onMounted(async () => {
    if (selectedTarget.value === undefined && targetId.value != undefined) {
        await getSelectedTarget()
    }
});



const getDisplayName = (name: string, path: string) => {
    let pathSlice = path.split("/:")
    if (pathSlice.length === 1) {
        return name
    } else {
        let param = pathSlice[pathSlice.length - 1]
        let value = typeof (route.params[param]) === "string" ? route.params[param] : route.params[param][0]
        if (param === 'targetId' && selectedTarget.value !== undefined) {
            if (selectedTarget.value.description === "") {
                return value
            } else {
                return value + '(' + selectedTarget.value.description + ')'
            }
        } else {
            return value

        }
    }
}

watchEffect(() => {
    paths.value = route.matched.filter(
        subRoute => {
            const tmpName: string = typeof (subRoute.name) === "string" ? subRoute.name : "";
            return !excludePaths.includes(tmpName);
        }
    )
        .map(subRoute => {
            return {
                name: subRoute.name as string,
                path: subRoute.path as string,
                redirect: subRoute.redirect,
            }
        }) as RouteRecordRaw[];
});



return (_ctx: any,_cache: any) => {
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")!
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (selectedTarget.value !== undefined)
      ? (_openBlock(), _createBlock(_component_el_breadcrumb, {
          key: 0,
          seperator: "/"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paths.value, (item, index) => {
              return (_openBlock(), _createBlock(_component_el_breadcrumb_item, {
                key: index,
                to: { name: item.name } as string
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString((getDisplayName(item.name, item.path))), 1)
                ]),
                _: 2
              }, 1032, ["to"]))
            }), 128))
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})